var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-h-20 overflow-y-auto "},[_vm._l((_vm.items),function(item,idx){return [_c('p',{key:(idx + "-" + (item.value)),staticClass:"mt-1 truncate text-md text-gray-500"},[_vm._v(_vm._s(item.value))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }